class Burger {
  stateClasses = {
    active: "nav--open",
    noScroll: "no-scroll",
  };
  constructor($el) {
    this.$el = $el;
    this.$body = $("body");
    this.$html = $("html");
    this.isOpen = false;

    this.init();
  }

  init = () => {
    console.log("burger initted");
    this.$el.on("click", this.clickHandler);
  };

  clickHandler = () => {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  };

  open = () => {
    this.$body.addClass(this.stateClasses.active);
    this.$html.addClass(this.stateClasses.noScroll);
    this.isOpen = true;
  };

  close = () => {
    this.$body.removeClass(this.stateClasses.active);
    this.$html.removeClass(this.stateClasses.noScroll);
    this.isOpen = false;
    $(document).trigger("burger:close");
  };
}

export default Burger;
